module.exports = __webpack_public_path__ + "img/youtube.6e6bc20e.svg";